export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/AR-87bf5e86e15df6ace37bb8fd8fdad4f5.png";